// extracted by mini-css-extract-plugin
export default {"userDetailsCardWrapper":"UpdateUserDetails_userDetailsCardWrapper__C5g3z"};